import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import LandingPage from './pages/LandingPage';
import CountdownTimer from './pages/CountdownTimer';
import Calculator from './pages/Calculator';
import UnitConverter from './pages/UnitConverter';
import PasswordGenerator from './pages/PasswordGenerator';
import QRCodeGenerator from './pages/QRCodeGenerator';
import ColorPicker from './pages/ColorPicker';
import CurrencyConverter from './pages/CurrencyConverter';
import LinkShortener from './pages/LinkShortener';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="app">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/countdown-timer" element={<CountdownTimer />} />
              <Route path="/calculator" element={<Calculator />} />
              <Route path="/unit-converter" element={<UnitConverter />} />
              <Route path="/password-generator" element={<PasswordGenerator />} />
              <Route path="/qr-generator" element={<QRCodeGenerator />} />
              <Route path="/color-picker" element={<ColorPicker />} />
              <Route path="/currency-converter" element={<CurrencyConverter />} />
              <Route path="/link-shortener" element={<LinkShortener />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App; 